export default __webpack_public_path__ + "media/images/void-cf1819950446c7563cdb09966c0db01d.png";